module.exports = __webpack_public_path__ + "img/swiper-3.ab837997.png";